import { useSelector } from 'react-redux';
import { UserRoles } from '~/services/config';

export const manageRoutes = [
    //{ path: '/hcm', title: 'Workflows', header: true, perm: UserRoles.EMPLOYEE },
    //{ path: '/hcm/report-checkout/individual', title: 'Daily Scores', perm: UserRoles.EMPLOYEE },
    //{ path: '/hcm/dashboard', title: 'Dashboard', perm: UserRoles.EMPLOYEE },
    //// { path: '/hcm/daily-plan', title: 'Daily', perm: UserRoles.EMPLOYEE },
    //
    //{ path: '/hcm/report-careers/employee/individual/view', title: 'Health Plan', perm: UserRoles.EMPLOYEE },
    //{ path: '/hcm/training-feed', title: 'Learning', perm: UserRoles.EMPLOYEE },
    //{ path: '/hcm/report-performance/individual', title: 'Monthly Coaching', perm: UserRoles.EMPLOYEE },
    //{ path: '/hcm/tasks-projects', title: 'Tasks', perm: UserRoles.EMPLOYEE },
    //{ path: '/hcm/reports', title: 'Reports', header: true, perm: UserRoles.MANAGER },
    //{ path: '/hcm/reports', title: 'All Reports', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-assignments', title: 'Assignments', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-certifications', title: 'Certifications', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-manager-dashboard', title: 'Coach\'s Dashboard', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-checkout', title: 'Daily Scores', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-engagement', title: 'Engagement', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-careers', title: 'Health Plan', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-training', title: 'Learning', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-performance', title: 'Monthly Results', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-signature', title: 'Signature', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-task', title: 'Tasks', perm: UserRoles.MANAGER },
    //{ path: '/hcm/report-training-schedule', title: 'Training Schedule', perm: UserRoles.MANAGER },
    //{ path: '/hcm/record-add-company', title: 'Add Company', perm: UserRoles.SUPER_ADMIN },
];

export const developRoutes = [
    { path: '/library/library', title: 'Library', header: true, perm: UserRoles.EMPLOYEE },
    { path: '/library/quotas', title: 'Goals', perm: UserRoles.EMPLOYEE },
    { path: '/library/scorecards', title: 'Scorecards', perm: UserRoles.EMPLOYEE },
    { path: '/library/career/careers', title: 'Health Plans', perm: UserRoles.EMPLOYEE },
    { path: '/library/training', title: 'Learning', perm: UserRoles.EMPLOYEE },
    //{ path: '/library/certification/certifications', title: 'Certifications', perm: UserRoles.EMPLOYEE },
    //{ path: '/library/documents', title: 'Documents', perm: UserRoles.EMPLOYEE },
    // { path: '/library/questionnaires', title: 'Questionnaires', perm: UserRoles.EMPLOYEE },
    // { path: '/library/to-do', title: 'Habits', perm: UserRoles.EMPLOYEE },
    
    
    
    //{ path: '/library/reports', title: 'Reports', header: true, perm: UserRoles.MANAGER },
    //{ path: '/hcm/reports', title: 'All Reports', perm: UserRoles.MANAGER },
    //{ path: '/library/report-assignments', title: 'Assignments', perm: UserRoles.MANAGER },
    //{ path: '/library/report-careers', title: 'Career', perm: UserRoles.MANAGER },
    //{ path: '/library/report-certifications', title: 'Certifications', perm: UserRoles.MANAGER },
    //{ path: '/library/report-engagement', title: 'Engagement', perm: UserRoles.MANAGER },
    //{ path: '/library/report-performance', title: 'Performance', permission: UserRoles.MANAGER },
    //{ path: '/library/report-task', title: 'Tasks', permission: UserRoles.MANAGER },
    //{ path: '/library/report-training', title: 'Training', perm: UserRoles.MANAGER },
    //{ path: '/library/report-training-schedule', title: 'Training Schedule', perm: UserRoles.MANAGER },
];

export const communityRoutes = () => {
    const community = useSelector((state) => state.app.user?.community_user);
    return [
        //{ path: '/community', title: 'Community', header: true, perm: UserRoles.EMPLOYEE },
        //{ path: '/community/home', title: 'Home', perm: UserRoles.EMPLOYEE },
        //{ path: `/${community?.entity?.slug}/about`, title: 'Profile', perm: UserRoles.EMPLOYEE },
        //{ path: '/community/blogs', title: 'Blogs', perm: UserRoles.EMPLOYEE },
        //{ path: '/forums', title: 'Forums', perm: UserRoles.EMPLOYEE },
        // { path: '/community/network', title: 'Network', perm: UserRoles.EMPLOYEE },    // temporarily hide
    ];
};

export const vendorRoutes = [
    //{ path: '/vendor-ratings', title: 'Vendor Ratings', header: true, perm: UserRoles.EMPLOYEE },
    //{ path: '/vendor-ratings/home', title: 'Home', perm: UserRoles.EMPLOYEE },
    //{ path: '/vendor-ratings/by-category', title: 'By Category', perm: UserRoles.EMPLOYEE },
    //{ path: '/vendor-ratings/by-company', title: 'By Company', perm: UserRoles.EMPLOYEE },
    //{ path: '/vendor-ratings/dealer-satisfaction-award', title: 'Dealer Satisfaction Award', perm: UserRoles.EMPLOYEE },
    //{ path: '/vendor-ratings/buyer-guide', title: `Buyer's Guide`, perm: UserRoles.EMPLOYEE },
    // { path: '/vendor-ratings/by-name', title: 'By Name', perm: UserRoles.EMPLOYEE },
    // { path: '/vendor-ratings/rate-vendor', title: 'Rate a Vendor', perm: UserRoles.EMPLOYEE },
    // { path: '/vendor-ratings/add-vendor', title: 'Add a Vendor', perm: UserRoles.ADMIN },
    // { path: '/vendor-ratings/faq', title: 'FAQ', perm: UserRoles.EMPLOYEE },
    // { path: '/vendor-ratings/super-admin', title: 'Super Admin', header: true, perm: UserRoles.SUPER_ADMIN },
    // { path: '/vendor-ratings/company-mgt', title: 'Company Management', perm: UserRoles.SUPER_ADMIN },
    // { path: '/vendor-ratings/content-mgt', title: 'Content Management', perm: UserRoles.SUPER_ADMIN },
    // { path: '/vendor-ratings/featured-content', title: 'Featured Content', perm: UserRoles.SUPER_ADMIN },
    // { path: '/vendor-ratings/user-mgt', title: 'User Management', perm: UserRoles.SUPER_ADMIN },
    // { path: '/vendor-ratings/vr-category-mgt', title: 'Vendor Ratings Categories', perm: UserRoles.SUPER_ADMIN },
    // { path: '/vendor-ratings/vr-rating-mgt', title: 'Vendor Ratings Moderation', perm: UserRoles.SUPER_ADMIN },
    // { path: '/hcm/record-add-company', title: 'Add Company', perm: UserRoles.SUPER_ADMIN },
    // { path: '/hcm/record-add-employee', title: 'Add User', perm: UserRoles.SUPER_ADMIN },
];

export const superAdminRoutes = [
    //{ path: '/vendor-ratings/super-admin', title: 'Super Admin', header: true, perm: UserRoles.SUPER_ADMIN },
    //{ path: '/vendor-ratings/company-mgt', title: 'Company Management', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/vendor-ratings/content-mgt', title: 'Content Management', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/vendor-ratings/featured-content', title: 'Featured Content', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/vendor-ratings/user-mgt', title: 'User Management', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/vendor-ratings/vr-category-mgt', title: 'Vendor Ratings Categories', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/vendor-ratings/vr-rating-mgt', title: 'Vendor Ratings Moderation', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/hcm/record-add-company', title: 'Add Company', perm: UserRoles.SUPER_ADMIN },
    //{ path: '/hcm/record-add-employee', title: 'Add User', perm: UserRoles.SUPER_ADMIN },
];
